/* eslint-disable */
const i18n = {
  "zh-TW": {
    "error": {
      "billing": {
        "missing_field": "很抱歉，您的交易已遭拒絕，請檢查您必填欄位中的填寫內容：國家/地區、城市及地址。",
        "stripe": {
          "generic_error": "錯誤！系統目前無法處理您的要求，請稍後再試，或是改用其他付款方式。若問題持續發生，請聯絡您的銀行或改用不同的付款方式。若問題依舊存在，請<a href=\"https://support.zoom.us/hc/en-us/requests/new?ticket_form_id=360000983032\">提交申請</a>給Zoom以尋求協助。",
          "authentication_required": "由於信用卡號碼無效，無法處理您的購買。請更新信用卡資訊或嘗試使用不同的付款方式。若問題持續發生，建議向您的銀行洽詢。",
          "approve_with_id": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "call_issuer": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "card_not_supported": "此卡不能使用此交易類型。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "card_not_supported_invoice": "此信用卡不允許此交易類型。請聯絡您的銀行或瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "card_velocity_exceeded": "此付款因資金相關問題遭拒，可能是銀行帳戶中餘額不足或超過信用卡額度。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "card_velocity_exceeded_invoice": "由於帳戶資金不足，付款已遭拒絕，請聯絡您的銀行或瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "currency_not_supported": "因為此卡片不支援付款貨幣，此付款遭拒。 請將貨幣切換為美元，然後再試一次，或嘗試使用其他信用卡。 如果問題持續發生，請聯絡您的銀行。",
          "do_not_honor": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "do_not_try_again": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "expired_card": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "expired_card_invoice": "由於信用卡號碼無效，無法處理您的購買。請瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。若問題持續發生，建議向您的銀行洽詢。",
          "fraudulent": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "generic_decline": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_number": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_cvc": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_pin": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_zip": "地址無效，無法處理您的訂單。 請確認您輸入的信用卡地址與銀行登記的地址相符，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_zip_invoice": "由於地址無效，無法處理您的購買，請瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "insufficient_funds": "此付款因資金相關問題遭拒，可能是銀行帳戶中餘額不足或超過信用卡額度。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "insufficient_funds_invoice": "由於帳戶資金不足，付款已遭拒絕，請聯絡您的銀行或瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "invalid_account": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_request": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_amount": "由於金額或貨幣有問題，付款遭拒。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_cvc": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_expiry_year": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_expiry_month": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_number": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_pin": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "issuer_not_available": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "lost_card": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "lost_card_invoice": "由於信用卡存在問題，我們無法處理此要求，請聯絡您的銀行或瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "merchant_blacklist": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "new_account_information_available": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "no_action_taken": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "not_permitted": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "offline_pin_required": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "online_or_offline_pin_required": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "pickup_card": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "pickup_card_invoice": "由於信用卡存在問題，我們無法處理此要求，請聯絡您的銀行或瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "pin_try_exceeded": "您已超出使用無效號碼處理此卡片付款的嘗試次數，請嘗試其他付款方式。",
          "processing_error": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "reenter_transaction": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "restricted_card": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "revocation_of_all_authorizations": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "revocation_of_authorization": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "security_violation": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "service_not_allowed": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "stolen_card": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "stolen_card_invoice": "由於信用卡存在問題，我們無法處理此要求，請聯絡您的銀行或瀏覽至<a href=\"/billing/payment\">帳單資訊</a>並更新您的付款資訊。",
          "stop_payment_order": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "testmode_decline": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "transaction_not_allowed": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "transaction_not_allowed_inr": "您的卡片不支援自動轉帳交易，很有可能是因為該張卡片屬於簽帳金融卡，請改用信用卡進行此項購買。",
          "try_again_later": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "card_decline_rate_limit_exceeded": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "withdrawal_count_limit_exceeded": "此付款因資金相關問題遭拒，可能是銀行帳戶中餘額不足或超過信用卡額度。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。"
        },
        "adyen": {
          "error_1": "由於付款方式存在問題，我們無法處理此要求。請聯絡您的銀行或嘗試其他付款方式。",
          "error_2": "由於信用卡號碼無效，無法處理您的購買。請更新信用卡資訊或嘗試使用其他付款方式。若問題持續發生，建議您聯絡您的銀行。",
          "error_3": "由於帳戶資金不足，付款已遭拒絕，請聯絡您的銀行或嘗試其他付款方式。",
          "error_4": "您已超出使用無效號碼處理此卡片付款的嘗試次數。請嘗試其他付款方式。",
          "error_5": "系統目前無法處理您的要求，請稍後再試一次，或是改用其他付款方式。若問題持續發生，請聯絡您的銀行或嘗試其他付款方式。",
          "error_6": "您已超出使用此付款方式處理付款的嘗試次數。請嘗試其他付款方式。",
          "error_7": "由於地址無效，無法處理您的購買。請更新付款資訊或選擇其他付款方式。",
          "currency_not_supported": "因為此卡片不支援付款貨幣，此付款遭拒。 請將貨幣切換為美元，然後再試一次，或嘗試使用其他信用卡。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_cvc": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_request": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "merchant_blacklist": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "do_not_try_again": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_zip": "地址無效，無法處理您的訂單。 請確認您輸入的信用卡地址與銀行登記的地址相符，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "issuer_not_available": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "withdrawal_count_limit_exceeded": "此付款因資金相關問題遭拒，可能是銀行帳戶中餘額不足或超過信用卡額度。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "insufficient_funds": "此付款因資金相關問題遭拒，可能是銀行帳戶中餘額不足或超過信用卡額度。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "generic_decline": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "offline_pin_required": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "not_permitted": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "expired_card": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "online_or_offline_pin_required": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "pickup_card": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_pin": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "call_issuer": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "card_velocity_exceeded": "此付款因資金相關問題遭拒，可能是銀行帳戶中餘額不足或超過信用卡額度。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "card_not_supported": "此卡不能使用此交易類型。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "lost_card": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_number": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_amount": "由於金額或貨幣有問題，付款遭拒。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "incorrect_cvc": "因卡片詳細資訊無效，無法處理您的購買。 原因可能包括卡號、到期日期或安全碼錯誤。 請確認您輸入的信用卡詳細資料與信用卡上顯示的完全相同，然後再試一次。 如果問題持續發生，請聯絡您的銀行。",
          "do_not_honor": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "approve_with_id": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "new_account_information_available": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "no_action_taken": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。",
          "invalid_account": "因卡片有不明問題，我們無法處理此付款。 請嘗試使用不同卡片或不同付款方式。 如果問題持續發生，請聯絡您的銀行。"
        }
      }
    },
    "billing": {
      "required": "必填",
      "enter_full_address": "請輸入完整地址。",
      "invalid": "無效",
      "transaction_declined": "交易被拒絕",
      "accept_terms_of_service": "請接受服務條款。",
      "invalid_quantity": "無效的數量",
      "not_european_country": "付款地址必須為歐盟境內地址。請使用其他計費方式以確認是否為歐盟境內居住地。",
      "expirationDate": "到期日期",
      "cvv": "CVV",
      "credit_card_number": "信用卡卡號",
      "card_hold_name": "持卡人姓名",
      "enter_special_characters": "您已輸入一個無效字元。 請移除|、~或^等符號以繼續進行。",
      "invalid_zip": "\u8ACB\u8F38\u5165 5 \u4F4D\u6578\u7684\u7F8E\u570B\u90F5\u905E\u5340\u865F",
      "invalid_jp_zip": "郵遞區號僅可包含數字",
      "invalid_in_zip": "請輸入 6 位數印度郵遞區號",
      "first_name": "\u540D\u5B57",
      "last_name": "\u59D3\u6C0F",
      "company_organization": "\u516C\u53F8/\u7D44\u7E54\u540D\u7A31",
      "email_address": "\u96FB\u5B50\u90F5\u4EF6\u5730\u5740",
      "place_order": "下訂單",
      "cancel": "\u53D6\u6D88",
      "pay_method": {
        "save_pay_method": "儲存付款方式",
        "verify_pay_method": "驗證付款方式"
      },
      "payment": {
        "paypal": "PayPal",
        "credit": "信用卡或簽帳卡",
        "apple_pay": "Apple Pay",
        "google_pay": "Google Pay",
        "credit_name": "\u4FE1\u7528\u5361",
        "change_payment": "變更付款方式",
        "apple_pay_desc": "按一下下方的按鈕，以從您的 Apple Pay 錢包中選取付款方式。 在您完成購買前，仍能檢視您的訂單。",
        "apple_pay_not_supported": "Apple Pay 付款選項僅支援執行 Safari 瀏覽器的合格 Apple 裝置。",
        "google_pay_desc": "按一下下方的按鈕，以從您的 Google Pay 錢包中選取付款方式。",
        "google_pay_not_supported": "您的裝置或網頁瀏覽器不支援 Google Pay 付款選項。",
        "payment_title": "\u652F\u4ED8\u65B9\u5F0F",
        "paypal_pending_desc": "您將前往 PayPal 以授權同意結算。 請確保允許彈出視窗。 我們此時不會向您收取費用。",
        "p24": "Przelewy24",
        "p24_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80Przelewy24\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002<br>\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "sofort": "Sofort",
        "sofort_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80SOFORT\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002<br>\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "sofort_upgrade_message": "SOFORT/SEPA\u7121\u6CD5\u7528\u65BC\u5347\u7D1A\u3002\u8ACB\u6309\u4E00\u4E0B\u300C\u7DE8\u8F2F\u300D\u9023\u7D50\u4EE5\u8B8A\u66F4\u60A8\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "customer_balance": "\u632f\u8fbc",
        "customer_balance_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80Furikomi\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002<br>\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "customer_balance_upgrade_message": "Furikomi無法用於升級。請按一下「編輯」連結以變更您的付款方式。",
        "ideal": "iDEAL",
        "ideal_desc": "\u7CFB\u7D71\u5C07\u5E36\u9818\u60A8\u524D\u5F80iDEAL\u4EE5\u6388\u6B0A\u8A08\u8CBB\u5408\u7D04\u3002\u8ACB\u78BA\u4FDD\u5141\u8A31\u5F48\u51FA\u8996\u7A97\u3002<br/>\u9019\u5C07\u6210\u70BA\u60A8\u5B58\u6A94\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "ideal_upgrade_message": "iDEAL/SEPA\u7121\u6CD5\u7528\u65BC\u5347\u7D1A\u3002\u8ACB\u6309\u4E00\u4E0B\u300C\u7DE8\u8F2F\u300D\u9023\u7D50\u4EE5\u8B8A\u66F4\u60A8\u7684\u4ED8\u6B3E\u65B9\u5F0F\u3002",
        "us_bank_account": "US ACH \u76f4\u63a5\u6263\u6b3e",
        "us_bank_account_desc": "\u60a8\u5c07\u524d\u5f80\u300c\u9280\u884c\u5e33\u6236\u8f49\u5e33\u300d\u4ee5\u6388\u6b0a\u540c\u610f\u7d50\u7b97\u3002\u8acb\u78ba\u4fdd\u672a\u963b\u64cb\u5f48\u51fa\u8996\u7a97\u3002\u9019\u5c07\u6210\u70ba\u60a8\u5efa\u6a94\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002\u8acb\u6ce8\u610f\uff1a\u6240\u8acb\u6c42\u7684\u5e33\u6236\u8b8a\u66f4\u53ef\u80fd\u56e0\u9280\u884c\u8f49\u5e33\u4f5c\u696d\u6642\u9593\u800c\u5ef6\u9072\u3002\u5982\u6709\u6025\u9700\uff0c\u8acb\u9078\u64c7\u5237\u5361\u4ed8\u6b3e\u3002",
        "us_bank_account_upgrade_message": "ACH \u9280\u884c\u8f49\u5e33\u4e0d\u80fd\u7528\u65bc\u5347\u7d1a\u3002 \u8acb\u6309\u4e00\u4e0b\u300c\u7de8\u8f2f\u300d\u9023\u7d50 \u4ee5\u8b8a\u66f4\u60a8\u7684\u4ed8\u6b3e\u65b9\u5f0f\u3002",
        "klarna": "立即購買，稍後支付",
        "klarna_desc": "您將前往Klarna以授權計費合約。請確保允許彈出視窗。這將成為您存檔的付款方式。",
        "klarna_upgrade_message": "Klarna 銀行轉帳不能用於升級。 請按一下「編輯」連結以變更您的付款方式。",
        "klarna_monthly_upgrade_message": "Klarna 僅可用於年度計費訂閱。 請切換至年度計費訂閱，或嘗試其他付款方式。",
        "klarna_payment_catgory": {
          "pay_in_installments": "分期付款",
          "pay_later": "稍後支付",
          "pay_now": "立刻支付",
          "pay_with_financing": "融資"
        },
        "wise_plus_banktransfer": "Wise + 銀行轉帳",
        "trustly": "Trustly +",
        "wise_plus_trustly": "Wise + Trustly",
        "interac": "Interac +",
        "wise_plus_interac": "Wise + Interac",
        "payid": "PayID +",
        "wise_plus_payid": "Wise + PayID",
        "fpx": "FPX +",
        "wise_plus_fpx": "Wise + FPX",
        "poli": "POLI +",
        "wise_plus_poli": "Wise + POLI",
        "paynow": "PayNow +",
        "wise_plus_paynow": "Wise + PayNow",
        "bacs": "BACS +",
        "wise_plus_bacs": "Wise+BACS",
        "fps": "FPS +",
        "wise_plus_fps": "Wise+FPS",
        "openbanking": "Open Banking +",
        "wise_plus_openbanking": "Wise+Open Banking",
        "wise_plus_boleto": "Wise + Boleto",
        "wise_plus_pix": "Wise + Pix",
        "wise": "Wise",
        "wise_upgrade_message": "Wise無法用於升級。請按一下「編輯」連結以變更您的付款方式。",
        "wise_desc": "您將前往 WISE 以授權同意結算。 請確保允許彈出視窗。 這將成為您資料中的付款方式。<br><br><strong>請注意：</strong>所請求的帳戶變更可能因銀行轉帳作業時間而延遲。 如有急需，請選擇刷卡付款。",
        "pay_with": "支付方式",
        "bill_same_as_contact": "這個付款方式使用下列地址",
        "waiting_auth_pay_method_title": "授權您的付款方式",
        "waiting_auth_pay_method_desc": "請勿關閉此頁面或點擊返回鈕。 前往彈出視窗以完成授權。",
        "waiting_updating_pay_method_title": "更新付款方式",
        "waiting_updating_pay_method_desc": "請勿關閉此頁面。",
        "waiting_check_title": "請稍候，您的訂單正在處理中...",
        "waiting_check_desc": "在回到上一頁或關閉瀏覽器之前，請稍候以完成確認。",
        "update_pay_method_tips": "請更新或取消您對付款方式的變更",
        "ach": {
          "name": "ACH",
          "verify_failed": "您的付款方式驗證失敗。 請導覽至<a href=\"/billing/payment\">帳單資訊</a>以更新您的付款方式。",
          "verify_pending_error": "由於您的付款方式正在等待驗證，因此您無法完成此付款。 請前往<a href=\"/billing/payment\">帳單資訊</a>並完成驗證，然後重新嘗試。"
        },
        "sepa": "SEPA",
        "others": "其他",
        "pay_with_international_card": "使用可用於國際購買的信用卡或簽帳卡支付。 向您的銀行確認可用性以及使用信用卡的任何費用",
        "apm_payment_error": "請嘗試其他付款方式。",
        "apm_flow_lost_message": "我們似乎無法順利進行。 請再試一次，使用 {0} 完成付款。"
      },
      "zip_postal": "\u90F5\u905E\u5340\u865F",
      "city": "\u5E02/\u93AE",
      "state": "\u5DDE/\u7701",
      "select_state": "\u9078\u53D6\u5DDE/\u7701",
      "country_region": "\u570B\u5BB6/\u5730\u5340",
      "company_organization_legal": "\u6CD5\u5B9A\u516C\u53F8\u540D\u7A31",
      "just_me": "\u53EA\u6709\u6211",
      "pop_up_blocked": "\u5FEB\u986F\u8996\u7A97\u5DF2\u88AB\u5C01\u9396\uFF0C\u8ACB\u5141\u8A31\u5FEB\u986F\u8996\u7A97\u4E26\u91CD\u8A66\u3002",
      "unknown_error": "\u672A\u77E5\u932F\u8AA4\uFF01",
      "not_vat_registered": "\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05",
      "vat_checkbox_desc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA\u6B50\u76DF\u6CD5\u898F\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
      "not_vat_tips": "\u82E5\u60A8\u662F\u5DF2\u8FA6\u7406\u767B\u8A18\u7684\u6B50\u76DF\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F",
      "vat_SN_message": "若您已登記繳納加值稅 (VAT)，請輸入稅務識別碼，以作為發票開立資訊。",
      "vat_SN_placeholder": "稅務識別碼",
      "vat_number": "VAT \u7A05\u865F",
      "amMsg": "\u8ACB\u8F38\u5165\u60A8\u7684\u589E\u503C\u7A05\u767B\u8A18\u865F\u78BC",
      "amMsgDesc": "\u4E00\u7D93\u6838\u53D6\u6B64\u65B9\u584A\uFF0C\u672C\u4EBA\u78BA\u8A8D\u81EA\u8EAB/\u6211\u5011\u5DF2\u5728\u4E9E\u7F8E\u5C3C\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u3002 \u672C\u4EBA\u5C0D\u65BC\u6B64\u8072\u660E\u7684\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u627F\u64D4\u6240\u6709\u8CAC\u4EFB\u3002 Zoom\u5C0D\u65BC\u6B64\u8072\u660E\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7684\u90E8\u4EFD\u4E0D\u627F\u64D4\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u5DF2\u5728\u4E9E\u7F8E\u5C3C\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA\u63A5\u53D7\u4E26\u77AD\u89E3Zoom\u5C07\u4E0D\u6703\u6536\u53D6\u4E9E\u7F8E\u5C3C\u4E9E\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u53EF\u80FD\u9700\u8981\u81EA\u884C\u8A55\u4F30\u61C9\u652F\u4ED8\u7684\u589E\u503C\u7A05\u3002",
      "mdMsgDesc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u975E\u4F01\u696D\u5BA2\u6236\uFF08\u5373\u91DD\u5C0D\u6469\u723E\u591A\u74E6\u7A05\u52D9\u76EE\u7684\u4E4B\u6CD5\u5F8B\u5BE6\u9AD4\uFF09\u3002 \u672C\u4EBA\u5C0D\u65BC\u6B64\u8072\u660E\u7684\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u627F\u64D4\u6240\u6709\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7A05\u52D9\u72C0\u614B\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u975E\u4F01\u696D\u5BA2\u6236\uFF08\u5373\u91DD\u5C0D\u6469\u723E\u591A\u74E6\u7A05\u52D9\u76EE\u7684\u4E4B\u6CD5\u5F8B\u5BE6\u9AD4\uFF09\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u5728\u9069\u7528\u60C5\u6CC1\u4E0B\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
      "vat_registration_placeholder": "\u589E\u503C\u7A05\u767B\u8A18\u865F\u78BC",
      "registered_for_vat": "\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05",
      "not_gst_tips_for_au": "若您是已註冊澳洲 GST 的企業，請輸入您的澳洲商業登記號碼 (「ABN」)。 提供澳洲商業登記號碼 (ABN) 即視同聲明您已註冊澳洲 GST，且取得 Zoom 服務係為在澳洲經營企業之目的 (而非基於私人或您國內的用途)。",
      "gst_number": "\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u865F\u78BC",
      "not_gst_registered": "\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05",
      "gst_checkbox_desc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3Zoom\u5C07\u6839\u64DA\u7576\u5730\u6CD5\u898F\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u3002",
      "vat_header_val_BS": "\u82E5\u60A8\u5DF2\u5728\u5DF4\u54C8\u99AC\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684TIN\uFF0C\u8A72\u7DE8\u865F\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
      "vat_header_val_BH": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u5DF4\u6797\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05ID\u7DE8\u865F\u3002",
      "vat_id_number_placeholder": "\u589E\u503C\u7A05ID\u7DE8\u865F",
      "vat_checkout_popup_message_IS_BH": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u6D88\u8CBB\u8005\u3001\u4F01\u696D\u6216\u653F\u5E9C\u6A5F\u95DC\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7A05\u52D9\u72C0\u614B\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u6D88\u8CBB\u8005\u3001\u4F01\u696D\u6216\u653F\u5E9C\u6A5F\u95DC\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u5728\u9069\u7528\u60C5\u6CC1\u4E0B\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
      "vat_header_val_BD": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165BIN",
      "vat_checkout_popup_message_BD": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
      "vat_header_val_BB": "\u82E5\u60A8\u5DF2\u5728\u5DF4\u8C9D\u591A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684\u589E\u503C\u7A05\u7DE8\u865F\uFF0C\u8A72\u7DE8\u865F\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
      "tin_number": "TIN\u865F\u78BC",
      "vat_header_val_KHM": "\u82E5\u60A8\u5DF2\u5728\u67EC\u57D4\u5BE8\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\u3002",
      "vat_checkout_popup_message_KHM": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
      "vat_header_val_CM": "如果您是企業客戶，請輸入您的 NIU，以作為發票開立資訊",
      "tax_promote_cl": "\u8ACB\u8F38\u5165\u60A8\u7684\u7A05\u7C4D\u7DE8\u865F\uFF08RUT\uFF09\uFF0C\u4E0D\u542B\u5C0F\u6578\u9EDE\u53CA\u9023\u5B57\u865F\u3002",
      "rut_number": "RUT\u865F\u78BC",
      "vat_header_val_GE": "\u82E5\u60A8\u5DF2\u5728\u55AC\u6CBB\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
      "vat_checkout_popup_message": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6{0}\u7684\u589E\u503C\u7A05\u3002",
      "vat_checkout_popup_message_GE": "\u55AC\u6CBB\u4E9E",
      "vat_header_val_GH": "\u82E5\u60A8\u5DF2\u5728\u52A0\u7D0D\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\u3002",
      "vat_header_val_IS": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u51B0\u5CF6\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05ID\u7DE8\u865F\u3002",
      "inMsg": "\u82E5\u60A8\u5C6C\u65BC\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u7684\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u865F\u78BC\u3002\u82E5\u7121\u6CD5\u63D0\u4F9B\u6709\u6548\u7684GSTIN\uFF0C\u5C07\u5C0E\u81F4\u7121\u6CD5\u958B\u7ACB\u96FB\u5B50\u767C\u7968\u3002\u5C07\u81EA\u52D5\u9A57\u8B49SEZ\u72C0\u614B\u3002<br /><br />ZVC India\u5FC5\u9808\u6838\u767C\u96FB\u5B50\u767C\u7968\u4E26\u63D0\u4F9B\u7D66\u5370\u5EA6\u5883\u5167\u8A3B\u518A\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u7684\u5BA2\u6236\u3002\u70BA\u4E86\u9054\u6210\u6B64\u76EE\u7684\uFF0C\u52D9\u5FC5\u78BA\u4FDD\u60A8\u7684\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u8A3B\u518A\u865F\u78BC\u6240\u6307\u6D3E\u7684\u5DDE\u8207\u4ED8\u6B3E\u53CA\u8CB7\u65B9\u5730\u5740\u7684\u6240\u5728\u5DDE\u4E00\u81F4\u3002",
      "gst_checkbox_desc_template": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u62D2\u7D55\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA{0}\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u3002",
      "tax_checkbox_desc_non_inr_in": "\u5370\u5EA6\u6CD5\u898F",
      "tax_promote_vat_cat1": "\u5982\u679C\u60A8\u662F\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u60A8\u7684\u589E\u503C\u7A05\u7DE8\u865F\uFF0C\u800C\u9019\u5C07\u6703\u986F\u793A\u5728Zoom\u70BA\u60A8\u958B\u7ACB\u7684\u767C\u7968\u4E0A",
      "tax_number_on_invoice_tips": "\u82E5\u60A8\u60F3\u8981\u5728\u7531Zoom\u7C3D\u767C\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u986F\u793A\u7D0D\u7A05\u7DE8\u865F\uFF0C\u8ACB\u5728\u9019\u88E1\u8F38\u5165\u8A73\u7D30\u8CC7\u6599\u3002",
      "vat_header_val_KAZ": "\u82E5\u60A8\u5DF2\u5728\u54C8\u85A9\u514B\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
      "vat_checkout_popup_message_KAZ": "\u54C8\u85A9\u514B",
      "keMsg": "\u8ACB\u8F38\u5165\u60A8\u7684\u500B\u4EBA\u8B58\u5225\u78BC\uFF08PIN\uFF09\uFF0C\u8A72\u8B58\u5225\u78BC\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
      "pin_number": "PIN\u78BC",
      "tax_promote_my": "\u5982\u679C\u60A8\u662F\u5DF2\u767B\u8A18\u7D0D\u7A05\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u60A8\u7684\u7D0D\u7A05\u7DE8\u865F\uFF0C\u800C\u9019\u5C07\u6703\u986F\u793A\u5728Zoom\u70BA\u60A8\u958B\u7ACB\u7684\u767C\u7968\u4E0A",
      "tax_checkbox_md": "\u975E\u4F01\u696D\u5BA2\u6236",
      "ngMsg": "\u5982\u679C\u60A8\u662F\u4F01\u696D\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u60A8\u7684\u7A05\u52D9\u8B58\u5225\u78BC\uFF08TIN\uFF09\uFF0C\u800C\u9019\u5C07\u6703\u986F\u793A\u5728Zoom\u70BA\u60A8\u958B\u7ACB\u7684\u767C\u7968\u4E0A\u3002",
      "tax_promote_no": "\u5728\u300CMVA\u300D\u524D\u9762\u8F38\u5165\u60A8\u76849\u4F4D\u6578\u589E\u503C\u7A05ID",
      "mva_number": "\u632A\u5A01\u589E\u503C\u7A05\uFF08MVA\uFF09\u7DE8\u865F",
      "tax_checkbox_desc_template": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA{0}\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
      "tax_checkbox_desc_no": "\u632A\u5A01\u6CD5\u898F",
      "vat_header_val_OM": "\u82E5\u60A8\u5DF2\u5728\u963F\u66FC\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
      "vat_checkout_popup_message_OM": "\u963F\u66FC",
      "vat_checkout_popup_message_RU": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u4FC4\u7F85\u65AF\u589E\u503C\u7A05\u3002",
      "tax_promote_default": "\u82E5\u60A8\u662F\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u7684\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F",
      "vat_header_val_RS": "\u82E5\u60A8\u5DF2\u5728\u585E\u723E\u7DAD\u4E9E\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684\u589E\u503C\u7A05\u7DE8\u865F\uFF0C\u8A72\u7DE8\u865F\u5C07\u8F09\u660E\u65BC\u958B\u7ACB\u7D66\u60A8\u7684\u767C\u7968\u4E0A\u3002",
      "not_gst_tips": "\u82E5\u60A8\u5C6C\u65BC\u767B\u8A18\u7E73\u7D0D\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u7684\u4F01\u696D\uFF0C\u8ACB\u8F38\u5165\u5546\u54C1\u53CA\u670D\u52D9\u7A05\u865F\u78BC",
      "vat_header_val_TW": "\u82E5\u60A8\u5DF2\u5728\u53F0\u7063\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
      "vat_checkout_popup_message_TW": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002 Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002 \u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u53F0\u7063\u589E\u503C\u7A05\u3002",
      "vat_header_val_TZ": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u767B\u8A18\u865F\u78BC\uFF08VRN\uFF09",
      "tax_promote_tr": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F",
      "tax_input_placeholder": "\u7A05\u52D9\u8B58\u5225\u78BC",
      "tax_checkbox_desc_tr": "\u571F\u8033\u5176\u6CD5\u898F",
      "ugMsg": "\u82E5\u60A8\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165TIN",
      "vat_header_val_UKR": "\u82E5\u60A8\u5DF2\u5728\u70CF\u514B\u862D\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u8ACB\u8F38\u5165\u589E\u503C\u7A05\u7DE8\u865F\u3002",
      "vat_checkout_popup_message_UKR": "\u70CF\u514B\u862D",
      "tax_checkbox_by": "\u514D\u7A05",
      "uzCheckboxMsg": "勾取此方塊即表示，我證實此舉係代表單一商業客戶 (例如：作為烏茲別克課稅對象的法人實體) 所為，且我本人並非作為烏茲別克課稅對象的個人或獨立企業。 我對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因聲明不完整或不準確的任何責任。 此外，為證明我係代表商業客戶行為，而非作為烏茲別克課稅對象的個人或獨立企業所為，我接受並理解 Zoom 並未收取烏茲別克增值稅，因此我在此代表的商業客戶應自行估算應繳增值稅。",
      "vat_header_val_VNM": "\u82E5\u60A8\u662F\u4F01\u696D\u5BA2\u6236\uFF0C\u8ACB\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\u3002\u4E00\u7D93\u8F38\u5165\u7A05\u52D9\u8B58\u5225\u78BC\uFF0C\u5373\u4EE3\u8868\u5BA2\u6236\u8072\u660E\u5176\u70BA\u4F01\u696D\u5BA2\u6236\uFF0C\u56E0\u6B64\u6709\u8CAC\u4EFB\u5411\u8D8A\u5357\u7A05\u52D9\u6A5F\u95DC\u7533\u5831\u4EFB\u4F55\u61C9\u4ED8\u7A05\u91D1\u3002",
      "vat_checkout_popup_message_VNM": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u7A05\u52D9\u72C0\u614B\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u672C\u4EBA/\u6211\u5011\u4E26\u672A\u767B\u8A18\u7D0D\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u6703\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\uFF08\u5982\u9069\u7528\uFF09\u3002",
      "tax_promote": {
        "include_your_vat_number": "\u82E5\u60A8\u662F\u5DF2\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\u7684\u5BA2\u6236\uFF0C\u8ACB\u9644\u4E0A\u589E\u503C\u7A05\u7DE8\u865F"
      },
      "tax_number_promote": {
        "default": "\u82E5\u60A8\u662F\u4F01\u696D\u5BA2\u6236\uFF0C\u8ACB\u8F38\u5165\u60A8\u7684\u7A05\u52D9\u8B58\u5225\u78BC"
      },
      "vat": {
        "GB_message": "如果您是企業客戶，請輸入 VAT 號碼",
        "local_tootip": "In completing the checkbox I/we certify that the above named business is not VAT registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not VAT registered I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in accordance to local legislation in addition to the prices listed in Order Summary.",
        "UK_tootip": "In completing the checkbox I/we certify that the above named business is not VAT registered and that I/we take full responsibility for the accuracy and completeness of this statement. Zoom waives any responsibility to accept liability due to either an incomplete or an inaccurate VAT registration disclosure. Furthermore, in certifying that the above named Business is not VAT registered I/we accept and understand that Zoom will charge VAT on all taxable services at the applicable rate in accordance to UK legislation in addition to the prices listed in Order Summary.",
        "msg_by": "如果您是企業客戶，請輸入您的稅務識別碼 (TIN)",
        "checkbox_by": "非企業客戶",
        "tooltip_by": "填寫此核取方塊時，我/我們證明我/我們不是白俄羅斯課稅目標的法人實體，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因聲明不完整或不準確的任何責任。 此外，證明我/我們不是白俄羅斯課稅目標的企業客戶同時，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "msg_co": "如果您已註冊 VAT，請輸入您的稅務識別碼 (RUT)",
        "placeholder_co": "RUT",
        "tooltip_co": "填寫核取方塊時，我/我們證明上述企業並非「增值稅主管單位」或增值稅收受單位，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因增值稅註冊披露不完整或不準確的任何責任。 此外，為證明上述提及企業非「增值稅主管單位」或增值稅收受單位，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "tooltip_cl": "填寫核取方塊時，我/我們證明上述企業未註冊增值稅，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因增值稅註冊披露不完整或不準確的任何責任。 此外，在證明上述企業未註冊增值稅時，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "tooltip_eg": "填寫核取方塊時，我/我們證明上述企業/個人未註冊增值稅，並且我/我們對本聲明的準確性和完整性承擔全部責任。 Zoom 免於承擔因增值稅註冊披露不完整或不準確的任何責任。 此外，在證明上述企業/個人未註冊增值稅時，我/我們接受並理解，除訂單摘要中列出的價格以外，Zoom 還將按適用稅率對所有應稅服務收取增值稅。",
        "msg_kr": "請輸入商業登記號碼",
        "msg_th": "如果您已註冊 VAT，請輸入您的 VAT 號碼",
        "tax_promote_eg": "如果您已註冊 VAT，請輸入您的稅務登記號碼",
        "tax_registration_number": "稅務登記號碼",
        "vat_cat2_checkbox_desc": "\u4E00\u7D93\u52FE\u9078\u6838\u53D6\u65B9\u584A\uFF0C\u5373\u8868\u793A\u672C\u4EBA/\u6211\u5011\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u4E14\u672C\u4EBA/\u6211\u5011\u627F\u64D4\u6B64\u8072\u660E\u4E4B\u7CBE\u78BA\u6027\u8207\u5B8C\u6574\u6027\u7684\u8CAC\u4EFB\u3002Zoom\u653E\u68C4\u627F\u64D4\u57FA\u65BC\u4E0D\u5B8C\u6574\u6216\u4E0D\u7CBE\u78BA\u589E\u503C\u7A05\u767B\u8A18\u63ED\u9732\u6240\u5C0E\u81F4\u7684\u4EFB\u4F55\u8CAC\u4EFB\u3002\u6B64\u5916\uFF0C\u4E00\u7D93\u8B49\u660E\u4E0A\u8FF0\u6307\u5B9A\u4F01\u696D\u4E26\u672A\u767B\u8A18\u7E73\u7D0D\u589E\u503C\u7A05\uFF0C\u672C\u4EBA/\u6211\u5011\u63A5\u53D7\u4E26\u77AD\u89E3\uFF0C\u9664\u4E86\u8A02\u55AE\u6458\u8981\u5167\u6240\u5217\u51FA\u7684\u50F9\u683C\u5916\uFF0CZoom\u9084\u5C07\u6839\u64DA\u7576\u5730\u6CD5\u898F\u4EE5\u9069\u7576\u8CBB\u7387\u91DD\u5C0D\u6240\u6709\u61C9\u7A05\u670D\u52D9\u6536\u53D6\u589E\u503C\u7A05\u3002",
        "tax_requirement": {
          "desc": "我理解，為遵循沙烏地阿拉伯法律，該地客戶必須預扣稅金、將相關稅額繳至相關單位、保留紀錄以證明扣稅準確性，並向 Zoom 提供個別扣稅證明。 我了解，若未能遵循上述要求，可能因沙烏地阿拉伯法律規定導致適用罰則。<br /><br />扣稅證明可寄至：<a href=\"mailto:{email}\">{email}</a>",
          "invalid_msg": "此核取方塊為必填"
        }
      },
      "export_control": {
        "biz_org_type": "\u696D\u52D9/\u7D44\u7E54\u985E\u578B",
        "input_placeholder": "\u8F38\u5165\u696D\u52D9/\u7D44\u7E54\u985E\u578B",
        "biz": "零售/批發",
        "fin": "\u9280\u884C\u6216\u5176\u4ED6\u91D1\u878D\u6A5F\u69CB",
        "edu": "幼稚園至高中教育",
        "med": "\u516C\u5171\u885B\u751F\u6216\u91AB\u7642\u6A5F\u69CB",
        "util": "\u516C\u7528\u4E8B\u696D",
        "telcomm": "\u570B\u5BB6\u96FB\u4FE1\u516C\u53F8",
        "edu_high": "\u5927\u5B78/\u9AD8\u7B49\u6559\u80B2",
        "sci_tech_inst": "\u79D1\u6280\u7814\u7A76\u9662\u6216\u570B\u5BB6\u5BE6\u9A57\u5BA4",
        "gov": "\u570B\u5BB6\u3001\u7701/\u5DDE\u653F\u5E9C\uFF0C\u6216\u5730\u65B9\u653F\u5E9C\u6A5F\u69CB\u3001\u8FA6\u516C\u5BA4\u3001\u6216\u90E8",
        "other": "\u5176\u4ED6",
        "adv": "廣告",
        "mfg": "製造與工業",
        "ps": "專業服務和管理顧問",
        "bp": "生技/製藥",
        "cnstr": "建築",
        "ent": "娛樂",
        "lgl": "法律",
        "hpy": "旅宿",
        "np": "非營利組織",
        "tech": "科技",
        "trans": "運輸",
        "re": "房地產"
      },
      "tax_exemption": {
        "ttr": {
          "link": "驗證免稅狀態",
          "link_desc": "請確保允許彈出視窗，以便將您引導至 ECMS 並驗證您的免稅狀態。",
          "in_progress_title": "進行免稅驗證中",
          "in_progress_desc": "請在我們的合作夥伴網頁上完成您的免稅驗證。 當您完成稅務狀態驗證後，您將返回此頁面以完成訂單。<br/><br/>請勿變更或關閉此頁面，直到驗證完成。 如果您不再需要進行免稅，您可以關閉並繼續下單。",
          "in_progress_close_button": "關閉",
          "quit_progress_title": "您確定嗎？",
          "quit_progress_desc": "您確定要放棄免稅驗證並以納稅資格繼續嗎？",
          "quit_progress_confirm": "是，放棄",
          "quit_progress_cancel": "否，繼續",
          "status_incomplete": "驗證未完成，如果您希望申請免稅請再按一下",
          "status_exempt": "免稅",
          "status_pending": "待公布",
          "status_retrieving": "擷取中…",
          "status_nonexempt": "非免稅",
          "tax_status_label": "稅務狀態：{0}",
          "status_pending_desc": "您的免稅狀態目前尚在審核。 下單後將向您收取稅費，若審核通過，我們將向帳戶貸記任何收取的稅金。",
          "status_retrieving_desc": "我們正在擷取您的免稅狀態，請稍候。"
        }
      },
      "video_sdk": {
        "use_case": "開發使用案例",
        "use_case_other": "如為其他情況，請說明"
      },
      "usecase": {
        "gaming": "Gaming",
        "retail": "Retail",
        "social": "Social",
        "wellness": "Wellness",
        "e_learning": "電子學習",
        "telehealth": "遠距醫療",
        "fintech": "金融科技",
        "legal": "法律",
        "hr_staffing": "人力資源/人力配置",
        "fitness": "健身",
        "events": "活動",
        "other": "其他"
      },
      "address": {
        "text": "\u5730\u5740",
        "street_address": "街道地址",
        "address_line2": "地址行 2",
        "phone": "\u96FB\u8A71\u865F\u78BC"
      },
      "addr": {
        "street_info": "街道地址資訊將做為「購買人」地址，以確定可能適用的任何稅款與費用。",
        "line_2": "地址行 2",
        "biz_info": "這是公司地址",
        "doing_biz_as_name": "\u4EE5\u516C\u53F8\u540D\u7A31\u8655\u7406\u696D\u52D9",
        "doing_biz_as_name_tips": "\u5982\u516C\u53F8\u5728\u71DF\u904B\u696D\u52D9\u6642\u4F7F\u7528\u7684\u540D\u7A31\u8207\u516C\u53F8\u64C1\u6709\u8005\u7684\u540D\u7A31\u6216\u6CD5\u5B9A\u540D\u7A31\u4E0D\u540C\uFF0C\u53EF\u9069\u7528\u6B64\u529F\u80FD\u3002",
        "business_size": "公司規模",
        "org_name": "組織名稱",
        "org_size": "組織規模",
        "hq": "公司總部國家/地區",
        "for_edu": {
          "tip": "此帳戶適用於有 18 歲以下兒童的學校或其他組織",
          "select_apply": "該組織為哪個年齡層的人提供服務？ (請選取所有適用的選項)*",
          "under_13": "13 歲以下",
          "range_n_m": "{0} 至 {1} 歲"
        }
      },
      "error": {
        "inr_non_india_error": "若要以 INR 完成購買，您的聯絡人地址必須在印度。 如果您要選取不同國家/地區，請",
        "inr_non_india_error_switch_to_usd": "切換為 USD",
        "empty_valid": "需要{0}",
        "required_field_not_completed": "未填寫必要欄位",
        "common": {
          "bank_account_number": "銀行帳號"
        },
        "ach": {
          "bank_routing_number": "銀行 ABA 碼/路由號碼",
          "bank_account_type": "銀行帳戶類型",
          "bank_name": "銀行名稱",
          "account_holder_name": "銀行帳戶持有人名稱"
        },
        "sepa": {
          "bank_account_name": "銀行帳戶名稱",
          "street_number": "街道地址",
          "street_name": "街道名稱",
          "account_email": "電子郵件",
          "account_country": "國家/地區"
        }
      },
      "terms": {
        "india_emandate_desc": "<p><b>eMandate 協議</b><br>為了向您的發卡機構註冊 eMandate，您在此授權 Zoom Video Communications 從您的卡片中扣除您所購買服務的訂閱費用，如以下 eMandate 詳細資訊所示：<br><br>eMandate 開始日期：{0}<br>eMandate 結束日期：{1}<br>金額：最高 {2} (Zoom 只會依據應付總金額收取費用)<br><br>這是為了確認您已仔細閱讀和理解該聲明。您瞭解此 eMandate 的註冊需要依據發卡機構的正當程序進行額外的身分驗證因素，並且您可以隨時撤回、檢視或修改此 eMandate。</p>",
        "emandate_charge_process_table": {
          "table_desc": "經常性費用如何處理？",
          "threshold_header": "收費金額",
          "threshold_1": "最高 {0}",
          "threshold_2": "超過 {0}",
          "action_header": "動作",
          "action_1": "我們將依據以下 eMandate 協議，透過 AutoPay 處理您在每個計費期間內的付款。",
          "action_2": "當您每個計費期間的付款到期時，我們會通知您。您每次都需要透過 <a href=\"https://zoom.us/paynow\" target=\"_blank\">zoom.us/paynow</a> 進行手動付款。"
        },
        "pay_method_tokenization_disclaimer": "您同意我們授權的第三方權杖服務供應商對您的卡片資料標記化，以讓我們儲存您偏好的付款方式並將其用於經常性費用。",
        "sepa_payment_terms": "一旦提供您的付款資訊並確認此付款，即表示您授權（A）Zoom Video Communications, Inc.與我們的付款服務供應商Stripe，和/或其當地服務供應商PPRO，向您的銀行傳送從您的帳戶扣款的指示，並授權（B）您的銀行根據這些指示對您的帳戶進行扣款。 作為您權利的一部分，您有權根據您與銀行之間合約的條款與條件，要求銀行退款。 退款必須自您的帳戶扣款日起8週內進行申請。 銀行提供的聲明中對您的權利有具體說明。 您同意在未來扣款兩天前收到通知。"
      }
    },
    "us": {
      "state_aa": "\u7F8E\u6D32\u8ECD\u4E8B\u57FA\u5730",
      "state_ae": "\u6B50\u6D32\u3001\u4E2D\u6771\u548C\u52A0\u62FF\u5927\u8ECD\u4E8B\u57FA\u5730",
      "state_ap": "\u592A\u5E73\u6D0B\u8ECD\u4E8B\u57FA\u5730",
      "state_al": "\u963F\u62C9\u5DF4\u99AC\u5DDE",
      "state_ak": "\u963F\u62C9\u65AF\u52A0\u5DDE",
      "state_az": "\u4E9E\u5229\u6851\u90A3\u5DDE",
      "state_ar": "\u963F\u80AF\u8272\u5DDE",
      "state_ca": "\u52A0\u5229\u798F\u5C3C\u4E9E\u5DDE",
      "state_co": "\u79D1\u7F85\u62C9\u591A\u5DDE",
      "state_ct": "\u5EB7\u4E43\u72C4\u514B\u5DDE",
      "state_wd": "\u83EF\u76DB\u9813\u54E5\u502B\u6BD4\u4E9E\u7279\u5340",
      "state_de": "\u5FB7\u62C9\u74E6\u5DDE",
      "state_fl": "\u4F5B\u7F85\u91CC\u9054\u5DDE",
      "state_ga": "\u55AC\u6CBB\u4E9E",
      "state_gu": "\u95DC\u5CF6",
      "state_hi": "\u590F\u5A01\u5937\u5DDE",
      "state_id": "\u611B\u9054\u8377\u5DDE",
      "state_il": "\u4F0A\u5229\u8AFE\u5DDE",
      "state_in": "\u5370\u7B2C\u5B89\u7D0D\u5DDE",
      "state_ia": "\u611B\u8377\u83EF\u5DDE",
      "state_ks": "\u582A\u85A9\u65AF\u5DDE",
      "state_ky": "\u80AF\u5854\u57FA\u5DDE",
      "state_la": "\u8DEF\u6613\u65AF\u5B89\u90A3\u5DDE",
      "state_me": "\u7DEC\u56E0\u5DDE",
      "state_md": "\u99AC\u91CC\u862D\u5DDE",
      "state_ma": "\u9EBB\u85A9\u8AF8\u585E\u5DDE",
      "state_mi": "\u5BC6\u897F\u6839\u5DDE",
      "state_mn": "\u660E\u5C3C\u8607\u9054\u5DDE",
      "state_ms": "\u5BC6\u897F\u897F\u6BD4\u5DDE",
      "state_mo": "\u5BC6\u8607\u91CC\u5DDE",
      "state_mt": "\u8499\u5927\u62FF\u5DDE",
      "state_ne": "\u5167\u5E03\u62C9\u65AF\u52A0\u5DDE",
      "state_nv": "\u5167\u83EF\u9054\u5DDE",
      "state_nh": "\u65B0\u7F55\u5E03\u590F\u5DDE",
      "state_nj": "\u7D10\u6FA4\u897F\u5DDE",
      "state_nm": "\u65B0\u58A8\u897F\u54E5\u5DDE",
      "state_ny": "\u7D10\u7D04",
      "state_nc": "\u5317\u5361\u7F85\u4F86\u90A3\u5DDE",
      "state_nd": "\u5317\u9054\u79D1\u4ED6\u5DDE",
      "state_oh": "\u4FC4\u4EA5\u4FC4\u5DDE",
      "state_ok": "\u5967\u514B\u62C9\u8377\u99AC\u5DDE",
      "state_or": "\u5967\u52D2\u5CA1\u5DDE",
      "state_pa": "\u8CD3\u5915\u6CD5\u5C3C\u4E9E\u5DDE",
      "state_pr": "\u6CE2\u591A\u9ECE\u5404",
      "state_ri": "\u7F85\u5FB7\u5CF6",
      "state_sc": "\u5357\u5361\u7F85\u4F86\u7D0D\u5DDE",
      "state_sd": "\u5357\u9054\u79D1\u4ED6\u5DDE",
      "state_tn": "\u7530\u7D0D\u897F\u5DDE",
      "state_tx": "\u5FB7\u514B\u85A9\u65AF\u5DDE",
      "state_ut": "\u7336\u4ED6\u5DDE",
      "state_vt": "\u4F5B\u8499\u7279\u5DDE",
      "state_va": "\u7DAD\u5409\u5C3C\u4E9E\u5DDE",
      "state_vi": "\u7DAD\u723E\u4EAC\u7FA4\u5CF6",
      "state_wa": "\u83EF\u76DB\u9813\u5DDE",
      "state_wv": "\u897F\u7DAD\u5409\u5C3C\u4E9E\u5DDE",
      "state_wi": "\u5A01\u65AF\u5EB7\u8F9B\u5DDE",
      "state_wy": "\u61F7\u4FC4\u660E\u5DDE"
    },
    "ca": {
      "state_aa": "\u4E9E\u4F2F\u9054\u7701",
      "state_ba": "\u5351\u8A69\u7701",
      "state_ma": "\u66FC\u5C3C\u6258\u5DF4\u7701",
      "state_nd": "\u65B0\u4F2F\u502B\u745E\u514B\u7701",
      "state_nr": "\u7D10\u82AC\u862D\u8207\u62C9\u5E03\u62C9\u591A",
      "state_ns": "\u897F\u5317\u9818\u5730",
      "state_na": "\u65B0\u65AF\u79D1\u7D30\u4E9E\u7701",
      "state_nt": "\u52AA\u52D2\u7DAD\u7279",
      "state_oo": "\u5B89\u5927\u7565\u7701",
      "state_pe": "\u611B\u5FB7\u83EF\u738B\u5B50\u5CF6",
      "state_qc": "\u9B41\u5317\u514B\u7701",
      "state_sn": "\u85A9\u514B\u5176\u842C",
      "state_yn": "\u80B2\u7A7A"
    },
    "inr": {
      "state_an": "\u5B89\u9054\u66FC-\u5C3C\u79D1\u5DF4",
      "state_ap": "\u5B89\u5F97\u62C9\u90A6",
      "state_ar": "\u963F\u9B6F\u7D0D\u6070\u723E\u90A6",
      "state_as": "\u963F\u85A9\u59C6",
      "state_br": "\u6BD4\u54C8\u723E",
      "state_ch": "\u660C\u8FEA\u52A0\u723E",
      "state_cg": "\u6070\u8482\u65AF\u52A0\u723E",
      "state_dnh": "\u9054\u5FB7\u62C9\u7D0D\u52A0\u723E\u54C8\u7DAD\u5229",
      "state_dd": "\u9054\u66FC-\u7B2C\u70CF",
      "state_dl": "\u5FB7\u91CC",
      "state_ga": "\u679C\u963F",
      "state_gj": "\u53E4\u5409\u62C9\u7279",
      "state_hr": "\u54C8\u91CC\u4E9E\u7D0D",
      "state_hp": "\u559C\u99AC\u5055\u723E\u90A6",
      "state_jk": "\u67E5\u8B28-\u514B\u4EC0\u7C73\u723E",
      "state_jh": "\u8CC8\u574E\u5FB7",
      "state_ka": "\u5361\u7D0D\u5854\u514B",
      "state_kl": "\u5580\u62C9\u62C9",
      "state_la": "\u62C9\u9054\u514B",
      "state_ld": "\u62C9\u514B\u6C99\u7FA4\u5CF6",
      "state_mp": "\u4E2D\u592E\u90A6",
      "state_mh": "\u99AC\u54C8\u62C9\u65BD\u7279\u62C9",
      "state_mn": "\u66FC\u5C3C\u666E\u723E",
      "state_ml": "\u6885\u52A0\u62C9\u4E9E",
      "state_mz": "\u5BC6\u7D22\u85CD",
      "state_nl": "\u90A3\u52A0\u862D",
      "state_or": "\u5967\u91CC\u85A9",
      "state_ot": "\u5176\u4ED6\u9818\u571F",
      "state_ph": "\u65C1\u8FEA\u5207\u91CC",
      "state_pb": "\u65C1\u906E\u666E",
      "state_rj": "\u62C9\u8CC8\u65AF\u5766",
      "state_sk": "\u932B\u91D1",
      "state_tn": "\u6CF0\u7C73\u723E\u7D0D\u5FB7",
      "state_tg": "\u6CF0\u502B\u8FE6\u7D0D",
      "state_tr": "\u7279\u91CC\u666E\u62C9",
      "state_up": "\u5317\u65B9\u90A6",
      "state_uk": "\u5317\u963F\u574E\u5FB7",
      "state_wb": "\u897F\u5B5F\u52A0\u62C9"
    },
    "country": {
      "AF": "阿富汗",
      "AX": "奧蘭群島",
      "AL": "阿爾巴尼亞",
      "DZ": "阿爾及利亞",
      "AS": "美屬薩摩亞",
      "AD": "安道爾",
      "AO": "安哥拉",
      "AI": "英屬安吉拉",
      "AQ": "南極洲",
      "AG": "安提瓜及巴布達",
      "AR": "阿根廷",
      "AM": "亞美尼亞",
      "AW": "阿魯巴",
      "AC": "亞森欣島",
      "AU": "澳大利亞",
      "AT": "奧地利",
      "AZ": "亞塞拜然",
      "BS": "巴哈馬",
      "BH": "巴林",
      "BD": "孟加拉",
      "BB": "巴貝多",
      "BY": "白俄羅斯",
      "BE": "比利時",
      "BZ": "貝里斯",
      "BJ": "貝南",
      "BM": "百慕達",
      "BT": "不丹",
      "BO": "玻利維亞",
      "BA": "波斯尼亞及黑塞哥維那",
      "BW": "波札那",
      "BV": "波維特島",
      "BR": "巴西",
      "BQ": "波奈、聖佑達修斯和沙巴",
      "IO": "英屬印度洋地區",
      "VG": "英屬維京群島",
      "BN": "汶萊",
      "BG": "保加利亞",
      "BF": "布吉納法索",
      "BI": "蒲隆地",
      "KH": "柬埔寨",
      "CM": "喀麥隆",
      "CA": "加拿大",
      "IC": "加納利群島",
      "CT": "堪東與安德柏里島",
      "CV": "維德角",
      "KY": "開曼群島",
      "CF": "中非共和國",
      "EA": "休達和梅利利亞",
      "TD": "查德",
      "CL": "智利",
      "CN": "中國",
      "CX": "聖誕島",
      "CP": "克利珀頓島",
      "CC": "可可斯群島",
      "CO": "哥倫比亞",
      "KM": "科摩羅",
      "CD": "剛果民主共和國",
      "CK": "庫克群島",
      "CR": "哥斯大黎加",
      "CI": "科特迪瓦",
      "HR": "克羅埃西亞",
      "CU": "古巴",
      "CW": "古拉果",
      "CY": "賽普路斯",
      "CZ": "捷克",
      "DK": "丹麥",
      "DG": "迪亞哥加西亞島",
      "DJ": "吉布地",
      "DM": "多米尼克",
      "DO": "多米尼加共和國",
      "NQ": "毛德皇后地",
      "EC": "厄瓜多",
      "EG": "埃及",
      "SV": "薩爾瓦多",
      "GQ": "赤道幾內亞",
      "ER": "厄立特里亞",
      "EE": "愛沙尼亞",
      "ET": "衣索比亞",
      "EU": "歐洲聯盟",
      "FK": "福克蘭群島（馬爾維納斯群島）",
      "FO": "法羅群島",
      "FJ": "斐濟",
      "FI": "芬蘭",
      "FR": "法國",
      "GF": "法屬圭亞那",
      "PF": "法屬玻里尼西亞",
      "TF": "法屬南部屬地",
      "FQ": "法屬南部和南極領地",
      "GA": "加彭",
      "GM": "甘比亞",
      "GE": "喬治亞",
      "DE": "德國",
      "GH": "迦納",
      "GI": "直布羅陀",
      "GR": "希臘",
      "GL": "格陵蘭",
      "GD": "格瑞納達",
      "GP": "瓜地洛普",
      "GU": "關島",
      "GT": "瓜地馬拉",
      "GG": "根息島",
      "GN": "幾內亞",
      "GW": "幾內亞比索",
      "GY": "圭亞那",
      "HT": "海地",
      "HM": "赫德島及麥當勞島",
      "HN": "宏都拉斯",
      "HK": "香港特別行政區",
      "HU": "匈牙利",
      "IS": "冰島",
      "IN": "印度",
      "ID": "印尼",
      "IR": "伊朗伊斯蘭共和國",
      "IE": "愛爾蘭",
      "IM": "英屬曼島",
      "IL": "以色列",
      "IQ": "伊拉",
      "IT": "義大利",
      "JM": "牙買加",
      "JP": "日本",
      "JE": "澤西島",
      "JT": "澤西島",
      "JO": "約旦",
      "KZ": "哈薩克斯坦",
      "KE": "肯亞",
      "KI": "吉里巴斯",
      "KP": "朝鮮民主主義人民共和國",
      "KR": "大韓民國",
      "XK": "科索沃",
      "KW": "科威特",
      "KG": "吉爾吉斯斯坦",
      "LA": "寮人民民主共和國",
      "LV": "拉脫維亞",
      "LB": "黎巴嫩",
      "LS": "賴索托",
      "LR": "賴比瑞亞",
      "LY": "利比亞",
      "LI": "列支敦斯登",
      "LT": "立陶宛",
      "LU": "盧森堡",
      "MO": "澳門特別行政區",
      "MK": "北馬其頓",
      "MG": "馬達加斯加",
      "MW": "馬拉維",
      "MY": "馬來西亞",
      "MV": "馬爾地夫",
      "ML": "馬利",
      "MT": "馬爾他",
      "MH": "馬紹爾群島",
      "MQ": "法屬馬丁尼克",
      "MR": "茅利塔尼亞",
      "MU": "模里西斯",
      "YT": "馬約特",
      "FX": "法屬美特羅波利坦",
      "MX": "墨西哥",
      "FM": "密克羅尼西亞聯邦",
      "MI": "中途島",
      "MD": "摩爾多瓦共和國",
      "MC": "摩納哥",
      "MN": "蒙古",
      "ME": "蒙特內哥羅",
      "MS": "蒙哲臘",
      "MA": "摩洛哥",
      "MZ": "莫三比克",
      "MM": "緬甸",
      "NA": "納米比亞",
      "NR": "諾魯",
      "NP": "尼泊爾",
      "NL": "荷蘭",
      "AN": "荷屬安地列斯",
      "NT": "中立區",
      "NC": "新喀里多尼亞",
      "NZ": "紐西蘭",
      "NI": "尼加拉瓜",
      "NE": "尼日",
      "NG": "奈及利亞",
      "NU": "紐埃",
      "NF": "諾福克島",
      "VD": "越南北部",
      "MP": "北馬里亞納群島",
      "NO": "挪威",
      "OM": "阿曼",
      "QO": "離島大洋洲",
      "PC": "太平洋群島託管地",
      "PK": "巴基斯坦",
      "PW": "帛琉",
      "PS": "巴勒斯坦國",
      "PA": "巴拿馬",
      "PZ": "巴布亞紐幾內亞",
      "PY": "巴拉圭",
      "YD": "葉門人民民主共和國",
      "PE": "秘魯",
      "PH": "菲律賓",
      "PN": "皮特肯",
      "PL": "波蘭",
      "PT": "葡萄牙",
      "PR": "波多黎各",
      "QA": "卡達",
      "RE": "留尼旺",
      "RO": "羅馬尼亞",
      "RU": "俄羅斯聯邦",
      "RW": "盧安達",
      "BL": "聖巴瑟米",
      "SH": "聖赫勒拿、亞森欣、特里斯坦達庫尼亞群島",
      "KN": "聖基茨及尼維斯",
      "LC": "聖露西亞",
      "MF": "法屬聖馬丁",
      "PM": "聖皮埃及密克隆群島",
      "VC": "聖文森及格瑞納丁斯",
      "WS": "薩摩亞",
      "SM": "聖馬利諾",
      "ST": "聖多美及普林西比",
      "SA": "沙烏地阿拉伯",
      "SN": "塞內加爾",
      "RS": "塞爾維亞",
      "CS": "塞爾維亞與蒙特內哥羅",
      "SC": "塞席爾",
      "SL": "獅子山",
      "SG": "新加坡",
      "SX": "荷屬聖馬丁",
      "SK": "斯洛伐克",
      "SI": "斯洛維尼亞",
      "SB": "索羅門群島",
      "SO": "索瑪利亞",
      "ZA": "南非",
      "GS": "南喬治亞島及南三明治群島",
      "ES": "西班牙",
      "LK": "斯里蘭卡",
      "SR": "蘇利南",
      "SJ": "斯瓦爾巴及揚馬延",
      "SZ": "史瓦帝尼",
      "SE": "瑞典",
      "CH": "瑞士",
      "SY": "阿拉伯敘利亞共和國",
      "TW": "中國台灣",
      "TJ": "塔吉克斯坦",
      "TZ": "坦尚尼亞聯合共和國",
      "TH": "泰國",
      "TL": "東帝汶",
      "TG": "多哥",
      "TK": "托克勞",
      "TO": "東加",
      "TT": "特立尼達及多巴哥",
      "TA": "崔斯坦達庫尼亞",
      "TN": "突尼西亞",
      "TR": "土耳其",
      "TM": "土庫曼斯坦",
      "TC": "土克斯及開科斯群島",
      "TV": "吐瓦魯",
      "UM": "美國本土外小島嶼",
      "PU": "美屬太平洋群島",
      "VI": "美屬維京群島",
      "UG": "烏干達",
      "UA": "烏克蘭",
      "AE": "阿拉伯聯合酋長國",
      "GB": "英國",
      "US": "美利堅合眾國",
      "UY": "烏拉圭",
      "UZ": "烏玆別克斯坦",
      "VU": "萬那杜",
      "VA": "教廷",
      "VE": "委內瑞拉玻利瓦共和國",
      "VN": "越南",
      "WK": "威克島",
      "WF": "瓦利斯群島及富圖那群島",
      "EH": "西撒哈拉",
      "YE": "葉門",
      "ZM": "尚比亞",
      "SD": "蘇丹",
      "SS": "南蘇丹",
      "ZW": "辛巴威",
      "CG": "剛果",
      "PG": "巴布亞紐幾內亞",
      "XG": "全球行動衛星系統",
      "XC": "ITPCS試驗",
      "XT": "國際免費電話",
      "XV": "國際網路",
      "XR": "國際付費語音資訊服務",
      "XS": "共攤成本服務",
      "XD": "防災電信",
      "XP": "通用個人電信"
    }
  }
}
export default i18n
